import { render, staticRenderFns } from "./InstructionsMainView.vue?vue&type=template&id=ab1623a8&"
import script from "./InstructionsMainView.vue?vue&type=script&lang=js&"
export * from "./InstructionsMainView.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsMainView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports